import axios from "axios"
import { del, get, post, put, getFile } from "./api_helper"
import * as url from "./url_helper"
import qs from "qs"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postLogin = data =>
  post(
    url.POST_LOGIN,
    qs.stringify({
      ...data,
      grant_type: "password",
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  )
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data)

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

//update password
export const updatePassword = profile => put(url.CHANGE_PASSWORD_URL, profile)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data)

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data)

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data)

// get users
export const getUsers = () => get(url.USER_URL)
//delete user
export const deleteUser = userID => del(url.USER_URL + `/${userID}`)
//add user
export const addNewUser = user => post(url.ADD_NEW_USER, user)
//get user detail
export const getUserDetail = userID => get(url.USER_URL + `/${userID}`)
//update user
export const updateUser = user => put(url.USER_URL + `/${user.UserID}`, user)
//update user
export const updateUserPhoto = user =>
  post(url.PHOTO_URL + `/${user.UserID}`, user)

// get roles
export const getRoles = () => get(url.ROLE_URL)
// get role types
export const getRoleTypes = () => get(url.ROLE_TYPES_URL)

//reset zoom credentials
export const resetZoomCredentials = obj => post(url.ZOOM_UPDATE_TOKEN_URL, obj)

//get zoom auth URL
export const getZoomAuthURL = () => get(url.ZOOM_AUTH_URL)

export const getGenders = () => get(url.GET_GENDER_URL)

export const getHourTypes = () => get(url.HOUR_TYPE_URL)

/*Common helper functions */
// get countries
export const getCountries = () => get(url.COUNTRY_URL)
// get states
export const getStates = countryID => get(url.STATE_URL + `/${countryID}`)
// get cities
export const getCities = stateID => get(url.CITY_URL + `/${stateID}`)
// get availabilities
export const getAvailabilities = () => get(url.AVAILABILITIES_URL)
//get permission types
export const getPermissionTypes = () => get(url.GET_PERMISSION_TYPES_URL)
// get Notification Events
export const getNotificationEvents = () => get(url.GET_NOTIFICATION_EVENTS_URL)
// get Notification Recipients
export const getNotificationRecipients = () =>
  get(url.GET_NOTIFICATION_RECIPIENTS_URL)
// get Meeting start url
export const getMeetingStartURL = meetingKey =>
  get(url.MEETING_START_URL + `/${meetingKey}`)

// get Privacy types
export const getPrivacyTypes = objectTypeID =>
  get(url.GET_PRIVACY_TYPES_URL + `/${objectTypeID}`)
// get Available Types
export const getAvailableTypes = () => get(url.AVAILABLE_TYPES_URL)
// get documents
export const getDocuments = filter =>
  get(
    url.DOCUMENT_URL +
      `?objectID=${filter.objectID}&objectTypeID=${filter.objectTypeID}`
  )
//delete document
export const deleteDocument = objectArtifactID =>
  del(url.DOCUMENT_URL + `/${objectArtifactID}`)
//add document
export const addNewDocument = document => post(url.DOCUMENT_URL, document)
//download Activity attachment
export const downloadArtifactDocument = rowID =>
  getFile(url.DOWNLOAD_ARTIFACT_ATTACHMENT_URL + `/${rowID}`)

// get user availability
export const getUserAvailability = userID =>
  get(url.USER_AVAILABILITY_URL + `/${userID}`)

// add user availability
export const addUserAvailability = ({ userID, useravailability }) =>
  post(url.USER_AVAILABILITY_URL + `/${userID}`, useravailability)

// add user profile
export const addUserProfile = ({ userID, userprofile }) =>
  post(url.USER_PROFILE_URL + `/${userID}`, userprofile)

// get center profile
export const getProfile = () => get(url.CENTER_PROFILE_URL)
//get center profile detail
export const getProfileDetail = profileId =>
  get(url.CENTER_PROFILE_URL + `/${profileId}`)
//update center profile
export const updateProfile = profile =>
  put(url.CENTER_PROFILE_UPDATE_URL + `/${profile.CenterProfileID}`, profile)
//update center profile address
export const updateProfileAddress = address =>
  put(
    url.CENTER_PROFILE_ADDRESS_UPDATE_URL + `/${address.CenterProfileID}`,
    address
  )
//update center profile contact
export const updateProfileContact = contact =>
  put(
    url.CENTER_PROFILE_CONTACT_UPDATE_URL + `/${contact.CenterProfileID}`,
    contact
  )
//update center profile closing
export const updateProfileClosing = closing =>
  put(
    url.CENTER_PROFILE_CLOSING_UPDATE_URL + `/${closing.CenterProfileID}`,
    closing
  )
// update center operating hour
export const updateProfileOperatingHour = ({ profileID, operatinghour }) =>
  post(
    url.CENTER_PROFILE_OPEATING_HOUR_UPDATE_URL + `/${profileID}`,
    operatinghour.availability
  )
//delete center profile address
export const deleteProfileAddress = addressID =>
  del(url.CENTER_PROFILE_ADDRESS_UPDATE_URL + `/${addressID}`)
//delete center profile contact
export const deleteProfileContact = contactID =>
  del(url.CENTER_PROFILE_CONTACT_UPDATE_URL + `/${contactID}`)
//delete center profile closing
export const deleteProfileClosing = closingID =>
  del(url.CENTER_PROFILE_CLOSING_UPDATE_URL + `/${closingID}`)

export const getTheme = () => get(url.THEME_URL)
//update Theme
export const updateTheme = theme => post(url.UPDATE_THEME, theme)

//get BasicSettings
export const getBasicSettings = () => get(url.BASICSETINGS_URL + `/${1}`)
//update BasicSettings
export const updateBasicSettings = basicSetting =>
  post(url.UPDATE_BASICSETINGS, basicSetting, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })

// get Reports
export const getReports = () => get(url.REPORT_URL)
// get Report Detail
export const getReportDetail = reportID => get(url.REPORT_URL + `/${reportID}`)
// get Report Types
export const getReportTypes = () => get(url.REPORT_TYPE_URL)
//get Report Data
export const getReportData = obj =>
  get(
    url.REPORT_URL +
      `?reportID=${obj.reportID}&filterDate=${obj.filterDate}&filterEndDate=${obj.filterEndDate}`
  )

// get Notification
export const getNotifications = () => get(url.NOTIFICATION_URL)
//delete notification
export const deleteNotification = notificationID =>
  del(url.NOTIFICATION_URL + `/${notificationID}`)
//add notification
export const addNewNotification = notification =>
  post(url.ADD_NEW_NOTIFICATION, notification)
//get notification detail
export const getNotificationDetail = notificationID =>
  get(url.NOTIFICATION_URL + `/${notificationID}`)
//update notification
export const updateNotification = notification =>
  put(url.NOTIFICATION_URL + `/${notification.NotificationID}`, notification)

// get navigation
export const getNavigation = roleTypeId =>
  get(url.NAVIGATION_URL + `/${roleTypeId}`)

//get dashboard chart
export const getChartData = () => get(url.DASHBOARD_URL)
//get scheduled data
export const getScheduledData = centerId =>
  get(url.DASHBOARD_SCHEDULED_URL + `/${centerId}`)
//get live data
export const getLiveData = centerId =>
  get(url.DASHBOARD_LIVE_URL + `/${centerId}`)

// get users profile
export const getUserProfile = rowID => get(url.USER_URL + `/${rowID}`)
// get user profile
export const getUserProfileByID = userID =>
  get(url.USER_PROFILE_URL + `/${userID}`)

// get Events
//export const getEvents = () => get(url.GET_EVENTS)
export const getEvents = event =>
  get(url.GET_EVENTS + `/${event.filter}/${event.childID}`)

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event)

// update Event
export const updateEvent = event => put(url.UPDATE_EVENT, event)

// delete Event
export const deleteEvent = event =>
  del(url.DELETE_EVENT, { headers: { event } })

// get Payment Methods
export const getPaymentMethods = () => get(url.PAYMENT_METHOD_URL)
// add Wallet Transaction
export const addWalletTransaction = obj =>
  post(url.ADD_WALLET_URL + `/${obj.AdultID}`, obj.Values)
// get Wallet Transaction
export const getWalletTransaction = adultID =>
  get(url.WALLET_URL + `/${adultID}`)

// get RoleType Modules
export const getRoleTypeModules = roleTypeID =>
  get(url.ROLETYPE_MODULE_URL + `/${roleTypeID}`)
// add RoleType Modules
export const addRoleTypeModules = ({ roleTypeID, roleTypeModules }) =>
  post(url.ROLETYPE_MODULE_URL + `/${roleTypeID}`, roleTypeModules)

//Impersonation
export const updateImpersonateUser = userID =>
  put(url.UPDATE_IMPERSONATE_USER + `/${userID}`)
export const deleteImpersonateUser = userID =>
  put(url.DELETE_IMPERSONATE_USER + `/${userID}`)

export const resetUserPassword = email =>
  get(url.RESET_USER_PASSWORD_URL + `/${0}` + `?email=${email}`)

// get Subscription
export const getSubscriptions = () => get(url.SUBSCRIPTION_URL + `/sub`)
//delete licence
export const deleteSubscription = subscriptionID =>
  del(url.SUBSCRIPTION_URL + `/${subscriptionID}`)
//add licence
export const addNewSubscription = subscription =>
  post(url.ADD_NEW_SUBSCRIPTION, subscription)
//get licence detail
export const getSubscriptionDetail = subscriptionID =>
  get(url.SUBSCRIPTION_URL + `/${subscriptionID}`)
//update licence
export const updateSubscription = subscription =>
  put(url.SUBSCRIPTION_URL + `/${subscription.subscriptionID}`, subscription)
// get Subscription Type
export const getSubscriptionTypes = () => get(url.SUBSCRIPTION_TYPES_URL)

//Projects
export const getProjects = () => get(url.PROJECT_URL)
export const getProjectDetail = rowID =>
  get(url.PROJECT_DETAIL_URL + `/${rowID}`)
export const addProject = project => post(url.ADD_EDIT_PROJECT_URL, project)
export const updateProject = project =>
  post(url.ADD_EDIT_PROJECT_URL + `/${project.LearningProjectID}`, project)
export const getNNSNames = () => get(url.NNS_NAMES_URL)
export const getNNSStrands = () => get(url.NNS_STRANDS_URL)
export const getAwardPeriods = () => get(url.AWARD_PERIOD_URL)
export const getQuestionTypes = () => get(url.QUESTION_TYPES_URL)
export const getQuestionDetail = rowID =>
  get(url.QUESTION_DETAIL_URL + `/${rowID}`)
export const addQuestionResponse = payload =>
  post(url.QUESTION_RESPONSE_URL, payload)
export const getResponseOutcome = payload =>
  get(url.RESPONSE_OUTCOME_URL + `/${payload.userID}/${payload.projectID}`)
export const downloadQuestionnaireReport = (projectID, questionTypeID) =>
  getFile(
    url.QUESTION_REPORT_DOWNLOAD_URL + `/${projectID}` + `/${questionTypeID}`
  )
export const downloadInstanceReport = (
  projectRowID,
  questionTypeID,
  instanceID
) =>
  getFile(
    url.QUESTION_INSTANCE_REPORT_DOWNLOAD_URL +
      `/${projectRowID}` +
      `/${questionTypeID}` +
      `/${instanceID}`
  )

//Healthdays
export const getHealthdays = () => get(url.HEALTHDAY_URL)
export const getHealthdayDetail = rowID =>
  get(url.HEALTHDAY_DETAIL_URL + `/${rowID}`)
export const addHealthday = healthday =>
  post(url.ADD_EDIT_HEALTHDAY_URL, healthday)
export const updateHealthday = healthday =>
  post(url.ADD_EDIT_HEALTHDAY_URL + `/${healthday.HealthDayID}`, healthday)
export const getCentres = () => get(url.CENTRES_URL)
export const getCentreTypes = () => get(url.CENTRE_TYPES_URL)
export const getCentreDetail = rowID =>
  get(url.CENTRE_DETAIL_URL + `/${rowID}`)
export const addCentre = centre =>
  post(url.CENTRE_ADD_EDIT_URL, centre)
export const updateCentre = centre =>
  post(
    url.CENTRE_ADD_EDIT_URL + `/${centre.CentreID}`,
    centre
  )

export const getEthnicities = () => get(url.ETHNICITIES_URL)
export const getPhoneContracts = () => get(url.PHONECONTRACTS_URL)
export const getNDBNetworkTypes = () => get(url.NDBNETWORKTYPES_URL)
export const addHealthdayFile = request =>
  post(url.HEALTHDAY_FILE_UPLOAD_URL, request, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
export const addHealthdayDataUpload = () => post(url.HEALTHDAY_DATA_UPLOAD_URL)

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postLogin,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
}
